import { get } from 'lodash';
import template from 'url-template';

import {
    FETCH_SENSOR_DATA,
    SENSOR_DATA_LOAD_BEGIN,
    SENSOR_DATA_LOAD_END,
    SENSOR_DATA_LOAD_ERROR
} from '../actions/actionTypes';

import { handleNetworkError } from './applicationMessageActions';

import awsHeader from '../helpers/awsAuth';
import { setBobLoading } from './bobActions';
import { getErrorMessage } from '../helpers/errors';
import lambdaBaseApi from '../apis/lambda';

const SensorDataUrl = template.parse('sensordata{?equipmentId,sensorId,systemId}{&startTimestamp,endTimestamp,pageSize,page,desiredInterval}');
const DEFAULT_PAGE_LIMIT = 200;


export const fetchSensorData = (node, desiredInterval, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {

        let sensors = [];

        dispatch(beginLoading());
        dispatch(setBobLoading('PreviewSensorData'));

        const getPayload = async (page = 1) => {
            options.limit || (options.limit = DEFAULT_PAGE_LIMIT);

            const sensorDataRequest = {
                sensorId:       node.sensorId,
                startTimestamp: node.startTimestamp,
                endTimestamp:   node.endTimestamp,
                pageSize:       options.limit,
                page:           page
            };   

            const response = await lambdaBaseApi.get(
                SensorDataUrl.expand({
                    ...sensorDataRequest,
                    desiredInterval
                }),
                header
            );

            const payload = get(response, 'data.data', []);
            const totalCount = get(response, 'data.meta.totalCount', 0);

            sensors = [...sensors, ...payload];

            page++;
            if (payload.length > 0 && sensors.length < totalCount) {
                return await getPayload(page);
            }
            return;
        };

        await getPayload();

        sensors.sort((a, b) => {
            return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
        });

        dispatch({
            type:    FETCH_SENSOR_DATA,
            payload: sensors
        });
        
    } catch (error) {
        dispatch(errorLoading(getErrorMessage(error)));
        dispatch(handleNetworkError(error));
    } finally {
        dispatch(setBobLoading('PreviewSensorData'));
        dispatch(endLoading());
    }

};

const beginLoading = () => ({
    type:    SENSOR_DATA_LOAD_BEGIN,
    payload: null
});

const endLoading = () => ({
    type:    SENSOR_DATA_LOAD_END,
    payload: null
});

const errorLoading = (error) => ({
    type:    SENSOR_DATA_LOAD_ERROR,
    payload: error
});

export const clearSensorData = () => ({
    type:    FETCH_SENSOR_DATA,
    payload: []
});
